import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SidebarNav from './SidebarNav';
import TopBar from './TopBar';
import AskAiSheet from '@/components/ai/AskAiSheet';
import AskAiTrigger from '@/components/ai/AskAiTrigger';
import DetectiveTourProvider from '@/tour/DetectiveTourProvider';
import { cn } from '@/lib/utils';

// Routes that want edge-to-edge use of <main> (no padding, no scroll).
// The map workspace needs every pixel; tabular pages keep the muted padding.
const FULL_BLEED_ROUTES = ['/maps'];

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const fullBleed = FULL_BLEED_ROUTES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

  return (
    <div className="flex h-screen w-screen overflow-hidden">
      <SidebarNav />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        <main
          className={cn(
            'flex-1 bg-content',
            fullBleed
              ? 'overflow-hidden'
              : 'overflow-auto px-3 py-4 sm:px-4 lg:px-6 lg:py-6 2xl:px-8',
          )}
        >
          <Suspense
            fallback={
              <div className="p-6 text-sm text-muted-foreground">Loading…</div>
            }
          >
            {fullBleed ? (
              <Outlet />
            ) : (
              // Key on pathname so each route change replays the fadeIn.
              <div key={pathname} className="motion-safe:animate-fadeIn">
                <Outlet />
              </div>
            )}
          </Suspense>
        </main>
      </div>
      <AskAiTrigger />
      <AskAiSheet />
      {/* Above the router <Outlet/> (sibling of the <main> that renders it), so
          a tour step's navigate() swaps the page without unmounting the tour. */}
      <DetectiveTourProvider />
    </div>
  );
}
